module.exports = __webpack_public_path__ + "assets/img/0408.8ecb234d.png";